import translate from "../../common/functions/translate";
import { ReactComponent as PhoneNumber } from "../../common/images/phoneNumber.svg";
interface HelpFooterProps {
    title?: string
}

export const HelpFooter = ({ title }: HelpFooterProps) => {
    return (<>
        <h2 className="ds-text-heading--lg ds-u-margin-bottom--0">{title}</h2>
        <div>
            <PhoneNumber className={'phoneNumber'}/>
            <span className={'ds-u-margin-left--1'}>
                {translate("call_1_800_medicare")} (<a href="tel:18006334227">1-800-633-4227</a>)<br/>
                <p className={'ds-u-margin-left--4 ds-u-margin-top--05'}>TTY (<a href="tel:18774862048">1-877-486-2048</a>)</p>
            </span>
        </div>
    </>
    );
}